import type { TUser } from 'redux/reducers/user/types';
import { TTaskItem, TTaskStatus } from './types';

export const KANBAN_COLUMNS: { status: TTaskStatus; title: string }[] = [
	{ status: 'todo', title: 'To Do' },
	{ status: 'in_progress', title: 'In Progress' },
	{ status: 'in_review', title: 'In Review' },
	{ status: 'done', title: 'Done' },
];

const ASSIGNEE_ALEX: TUser = {
	id: 'synthetic-user-1',
	email: 'alex.morgan@example.com',
	fullName: 'Alex Morgan',
};

const ASSIGNEE_JORDAN: TUser = {
	id: 'synthetic-user-2',
	email: 'jordan.lee@example.com',
	fullName: 'Jordan Lee',
};

const ASSIGNEE_SAMIRA: TUser = {
	id: 'synthetic-user-3',
	email: 'samira.patel@example.com',
	fullName: 'Samira Patel',
};

const ASSIGNEE_CHRIS: TUser = {
	id: 'synthetic-user-4',
	email: 'chris.weber@example.com',
	fullName: 'Chris Weber',
};

/** Synthetic tasks for UI testing (replace with API data later). */
export const SYNTHETIC_TASKS: TTaskItem[] = [
	{
		id: 't1',
		title: 'Audit role matrix',
		description: 'Review admin vs standard permissions for the new VAT module.',
		assignee: ASSIGNEE_ALEX,
		status: 'todo',
	},
	{
		id: 't2',
		title: 'Onboarding checklist export',
		description: 'Add CSV export for merchant onboarding steps.',
		assignee: ASSIGNEE_JORDAN,
		status: 'todo',
	},
	{
		id: 't3',
		title: 'Error Correction bulk assign',
		description: 'Allow assigning up to 50 issues to one user from the grid.',
		assignee: ASSIGNEE_SAMIRA,
		status: 'in_progress',
	},
	{
		id: 't4',
		title: 'Invoice archive retention policy',
		description: 'Document default retention and legal hold exceptions.',
		assignee: ASSIGNEE_CHRIS,
		status: 'in_progress',
	},
	{
		id: 't5',
		title: 'HMRC CSV validator',
		description: 'Validate uploaded files against latest HMRC schema before submit.',
		assignee: ASSIGNEE_ALEX,
		status: 'in_review',
	},
	{
		id: 't6',
		title: 'User Management search',
		description: 'Debounce search and highlight matched email domains.',
		assignee: ASSIGNEE_JORDAN,
		status: 'in_review',
	},
	{
		id: 't7',
		title: 'Monthly fee notification copy',
		description: 'Finalize English copy for overdue fee reminders.',
		assignee: ASSIGNEE_CHRIS,
		status: 'done',
	},
	{
		id: 't8',
		title: 'EUDR document checklist',
		description: 'Ship checklist component on merchant detail page.',
		assignee: ASSIGNEE_SAMIRA,
		status: 'done',
	},
];
